// Source-language keys keep existing Uzbek copy stable. Domain values are never translated.
export const translations: Record<string, string> = Object.fromEntries(`
Xaridni qaytarish|Возврат закупки
Sotuvni qaytarish|Возврат продажи
Hujjat|Документ
Hujjat topilmadi|Документ не найден
Batafsil|Подробнее
Barchasini qaytarish|Вернуть всё доступное
Qaytarilmagan|Без возвратов
Qisman qaytarilgan|Частично возвращено
To'liq qaytarilgan|Полностью возвращено
Qaytarish mumkin|Доступен возврат
Qaytariladigan miqdor yo'q|Нет доступного количества
Yetkazib beruvchi ko'rsatilmagan|Поставщик не указан
Omborda:|На складе:
Qaytarish:|Возврат:
Qaytarish summasi|Сумма возврата
Oldingi qaytarish summasi asl qiymatdan oshgan. Qolgan tovar pulsiz qaytariladi.|Сумма прошлых возвратов превышает исходную стоимость. Остаток товара возвращается без дополнительного расчёта.
Qarzdan kamaytirish|Уменьшение долга
Qaytariladigan pul|Деньги к возврату
Qaytarib olinadigan pul|Деньги от поставщика
Pul qaytarish|Возврат денег
Mijoz qarzi:|Долг клиента:
Yetkazib beruvchiga qarz:|Долг поставщику:
Pul qaytarish uchun to'lov usulini tanlang.|Выберите способ возврата денег.
To'lov usullari yig'indisi qaytariladigan pulga teng bo'lishi shart.|Сумма по способам оплаты должна совпадать с возвратом денег.
Qarzdan kamaytirish va pul qaytarish summalarini tekshiring.|Проверьте уменьшение долга и возврат денег.
Miqdor yoki qarz o'zgardi. Hisob-kitobni tekshirib, qayta saqlang.|Количество или долг изменились. Проверьте расчёт и сохраните снова.
Miqdor o'zgarsa, hisob-kitob tavsiyasi yangilanadi. Summalarni tekshiring.|При изменении количества расчёт обновляется. Проверьте суммы.
So'rov bajarilmadi|Не удалось выполнить запрос
Qaytariladigan miqdor qolmagan yoki omborda mavjud emas.|Нет доступного количества для возврата.
Qaytarish miqdori o'zgardi. Summalarni tekshirib, qayta saqlang.|Количество возврата изменилось. Проверьте суммы и сохраните снова.
Qarz miqdori o'zgardi. Hisob-kitobni qayta tekshiring.|Долг изменился. Проверьте расчёт снова.
Qarzdan kamaytirish va pul qaytarish yig'indisi qaytarish summasiga teng bo'lishi shart.|Уменьшение долга и возврат денег должны составлять сумму возврата.
To'lov usullari bo'yicha summalar qaytariladigan pulga teng bo'lishi shart.|Сумма по способам оплаты должна совпадать с возвратом денег.
Pul qaytarilmasa, to'lov usuli ko'rsatilmaydi.|При нулевом возврате денег способ оплаты не указывается.
Har bir to'lov usulini bir marta tanlang.|Выберите каждый способ оплаты только один раз.
Summa ko'pi bilan ikki kasr xonasiga ega bo'lishi kerak.|В сумме допустимо не более двух знаков после запятой.
Bu qaytarish avval boshqa ma'lumotlar bilan yuborilgan.|Этот возврат уже отправлен с другими данными.
AD|AD
Qidirilmoqda…|Поиск…
Yuklanmoqda…|Загрузка…
O‘chirish|Удалить
Narxi|Цена
Bo‘sh|Пусто
Zaxira|Остаток
Oldingi xabar natijasini tekshirish|Проверить предыдущее сообщение
Keyingi xizmat|Следующее обслуживание
Eslatma|Напоминание
so‘m|сум
AvtoDaftar Usta|AvtoDaftar Мастер
Administrator javobi|Ответ администратора
Aloqa yo‘q|Нет связи
Amalni tasdiqlang|Подтвердите действие
Anonim|Без клиента
Asosiy bo‘limlar|Основные разделы
Avtomobil|Автомобиль
Avtomobil kartasi|Карточка автомобиля
Avtomobil qidirish|Поиск автомобиля
Avtomobil qo‘shish|Добавить автомобиль
Avtomobil tayyor|Автомобиль готов
Avtomobil topilmadi|Автомобиль не найден
Avtomobillar|Автомобили
Avtomobilni tahrirlash|Изменить автомобиль
Backend belgilagan zaxira|Остаток назначенного филиала
Band qilinadigan miqdor mavjud zaxiradan oshmasligi kerak.|Резерв не должен превышать доступный остаток.
Band qilingan tovarlar|Зарезервированные товары
Band qilish|Зарезервировать
Band:|Резерв:
Bank|Банк
Barcha bo‘limlar|Все разделы
Barchasi|Все
Batafsil matn|Подробное описание
Bekor qilingan|Отменено
Bekor qilish|Отмена
Bir qurilmada bitta faol ish qoralamasi saqlanadi.|На устройстве сохраняется один активный черновик работы.
Birinchi avtomobil|Первый автомобиль
Birinchi avtomobil raqamini kiriting.|Введите номер первого автомобиля.
Biz bilan aloqa|Связаться с нами
Biznes ruxsati yo‘q|Нет доступа к рабочим разделам
Bosh sahifa|Главная
Bosh sahifaga qaytish|Вернуться на главную
Bo‘limlar menyusi|Меню разделов
Bu WebView kamera skanerini qo‘llamaydi. Tovarni nomi yoki shtrix-kodi bilan qo‘lda toping.|Камера недоступна в этом WebView. Найдите товар по названию или штрихкоду вручную.
Bu avtomobil bo‘yicha ishlar yo‘q.|По этому автомобилю пока нет работ.
Bu bo‘lim uchun ruxsat yo‘q|Нет доступа к разделу
Bu ilova faqat ustaxona egasi va xodimlari uchun|Приложение доступно владельцу и сотрудникам мастерской
Bu mijozga avtomobil qo‘shilmagan.|У клиента пока нет автомобилей.
Bu ombor amali sizning vazifangizga biriktirilmagan.|Эта складская операция недоступна для вашей роли.
Bu tarif yoki vazifa bilan ehtiyot qism qo‘shib bo‘lmaydi.|Ваш тариф или роль не разрешает добавлять запчасти.
Bu tarifda ish to‘liq to‘langan hisoblanadi.|На этом тарифе работа учитывается как полностью оплаченная.
Bu tovar omborda mavjud emas.|Товара нет на складе.
Bugun sizga biriktirilgan ish yo‘q.|За сегодня у вас нет работ.
Bugungi ishlar|Работы за сегодня
Bugungi shaxsiy natijalar va ustaxona qidiruvi.|Ваши результаты за сегодня и поиск по мастерской.
Chiqish|Выйти
Chiqish va o‘chirish|Выйти и удалить
Chiqishni tasdiqlab bo‘lmadi|Не удалось подтвердить выход
Chiqishni tasdiqlab bo‘lmadi. Qayta urinib ko‘ring|Не удалось подтвердить выход. Попробуйте снова
Chiqishni tasdiqlab bo‘lmadi. Qayta urinib ko‘ring.|Не удалось подтвердить выход. Попробуйте снова.
Chiqishni tasdiqlasangiz ushbu ish qoralamasi o‘chiriladi.|После подтверждения выхода черновик работы будет удалён.
Chiroq|Фонарик
Chorak|Квартал
Davlat raqami|Госномер
Davlat raqamini kiriting.|Введите госномер.
Davom ettirish|Продолжить
Davr|Период
Ehtiyot qism keldi|Запчасть поступила
Ehtiyot qism qidirish|Поиск запчасти
Ehtiyot qism qo‘shilmagan.|Запчасти не добавлены.
Ehtiyot qism tanlang|Выберите запчасть
Ehtiyot qismlar|Запчасти
Ehtiyot qismlar miqdori va narxini tekshiring.|Проверьте количество и цены запчастей.
Erkin matn|Свободный текст
Eslatma 500 belgidan oshmasligi kerak.|Напоминание не должно превышать 500 символов.
Eslatma yaratildi:|Создано напоминание:
Faol|Активно
Faol tovarlar yo‘q.|Нет активных товаров.
Faqat sizga biriktirilgan ishlar.|Только ваши работы.
Filial backend tomonidan belgilanadi.|Филиал назначается сервером.
Filial belgilanmagan|Филиал не назначен
Filial server tomonidan belgilanadi va bu yerda o‘zgartirilmaydi.|Филиал назначается сервером и здесь не изменяется.
Filial zaxirasi, sotuv va ombor amallari.|Остатки филиала, продажи и складские операции.
Foydalanuvchi|Пользователь
Hafta|Неделя
Havola noto‘g‘ri yoki bu bo‘lim hali mavjud emas.|Ссылка неверна или раздел недоступен.
Havolani ochish|Открыть ссылку
Hisob va sessiya sozlamalari.|Настройки профиля и сеанса.
Hisobdan chiqarish|Списание
Hisobdan chiqarish sababini tanlang.|Выберите причину списания.
Hisobdan chiqarish saqlandi|Списание сохранено
Hisobingizda ushbu bo‘lim uchun kerakli huquq yo‘q.|У вас нет прав для этого раздела.
Hozircha ma’lumot yo‘q|Данных пока нет
Hozircha murojaatlar yo‘q|Обращений пока нет
Hozirgi kilometr|Текущий пробег
Ichki iste’mol|Внутреннее использование
Ichki izoh|Внутренний комментарий
Ilova tayyorlanmoqda…|Подготовка приложения…
Ilova yuklanmoqda|Загрузка приложения
Internet aloqasini tekshirib, qayta urinib ko‘ring|Проверьте подключение и попробуйте снова
Inventarizatsiya|Инвентаризация
Ish|Работа
Ish saqlandi|Работа сохранена
Ish saqlanmoqda…|Сохранение работы…
Ish yozish|Записать работу
Ishda qolish|Остаться в форме
Ishlab chiqarilgan yil|Год выпуска
Ishlab chiqarilgan yilni to‘g‘ri kiriting.|Введите корректный год выпуска.
Ishni saqlash|Сохранить работу
Ism va telefonni kiriting.|Введите имя и телефон.
Ism, telefon yoki raqam|Имя, телефон или госномер
Ixtiyoriy|Необязательно
Izoh|Комментарий
Izoh (ixtiyoriy)|Комментарий (необязательно)
Jami|Итого
Jami ish|Всего работ
Jarayonda|В процессе
Jarayondagi sotuv allaqachon yopilgan|Продажа уже завершена
Jarayondagi sotuv topilmadi|Продажа в процессе не найдена
Jarayondagi sotuv topilmadi yoki yakunlangan.|Продажа не найдена или уже завершена.
Javob berilgan|Есть ответ
Joriy parol|Текущий пароль
Juda ko‘p urinish. Birozdan keyin qayta urinib ko‘ring|Слишком много попыток. Попробуйте позже
Kamera band yoki ishga tushmadi.|Камера занята или не запустилась.
Kamera ruxsati kutilmoqda…|Ожидание разрешения камеры…
Kamera skaneri mavjud emas|Сканер камеры недоступен
Kameraga ruxsat berilmadi|Доступ к камере запрещён
Kamerani qayta ishga tushiring yoki qo‘lda qidiring.|Перезапустите камеру или воспользуйтесь ручным поиском.
Karta o‘tkazma|Перевод на карту
Kilometr|Пробег
Kilometrni to‘g‘ri kiriting.|Введите корректный пробег.
Kirish|Войти
Kiritilganlar o‘chadi|Введённые данные будут удалены
Kod yo‘q|Без кода
Ko‘rilgan|Просмотрено
Ko‘rsatilmagan|Не указано
Kutilmagan xatolik yuz berdi|Произошла непредвиденная ошибка
Mavjud|Доступно
Mavjud mijoz|Существующий клиент
Mavjud:|Доступно:
Mavzu|Тема
Fon|Фон
Ma’lumot topilmadi|Данные не найдены
Ma’lumotni yuklab bo‘lmadi|Не удалось загрузить данные
Menyuni yopish|Закрыть меню
Mijoz|Клиент
Mijoz (ixtiyoriy)|Клиент (необязательно)
Mijoz Telegram holati|Статус Telegram клиента
Mijoz Telegram xabarlarini bloklagan|Клиент заблокировал сообщения Telegram
Mijoz Telegramga ulangan|Клиент подключён к Telegram
Mijoz bilan Telegram bog‘lanishi hozir faol.|Подключение клиента к Telegram активно.
Mijoz hali Telegramga ulanmagan|Клиент ещё не подключён к Telegram
Mijoz ismi|Имя клиента
Mijoz qidirish|Поиск клиента
Mijoz saqlandi; avtomobilni qayta saqlashingiz mumkin.|Клиент сохранён; можно повторить сохранение автомобиля.
Mijoz topilmadi|Клиент не найден
Mijoz uchun eslatma|Напоминание клиенту
Mijoz va avtomobil|Клиент и автомобиль
Mijoz va avtomobilni tanlang.|Выберите клиента и автомобиль.
Mijoz va uning birinchi avtomobilini birga saqlang.|Сохраните клиента вместе с его первым автомобилем.
Mijoz yoki raqam qidirish|Поиск клиента или госномера
Mijozlar|Клиенты
Mijozni tahrirlash|Изменить клиента
Mijozni tanlang.|Выберите клиента.
Mijozning asosiy ma’lumotlari.|Основные данные клиента.
Mini App ochiq qoladi. Tasdiqlashni tugatgach bosh sahifaga qayting.|Приложение останется открытым. Завершив подтверждение, вернитесь на главную.
Miqdor|Количество
Miqdorni kamaytirish|Уменьшить количество
Miqdorni oshirish|Увеличить количество
Model|Модель
Model kiritilmagan|Модель не указана
Mos avtomobil topilmadi.|Подходящий автомобиль не найден.
Mos ehtiyot qism topilmadi.|Подходящая запчасть не найдена.
Mos tovar topilmadi.|Подходящий товар не найден.
Muddati o‘tgan|Просрочено
Murojaat|Обращение
Murojaat topilmadi|Обращение не найдено
Murojaatlarim|Мои обращения
Naqd|Наличные
Natija aniqlanmaguncha maydonlar o‘zgartirilmaydi.|Поля нельзя менять, пока результат не определён.
Natija noma’lum. Operatsiya raqami saqlandi; yangi amal boshlanmaydi. Sessiyani tiklab xavfsiz tekshiring.|Результат неизвестен. Операция сохранена; новая не начнётся. Восстановите сеанс и проверьте результат.
Natijani qayta tekshirish|Проверить результат повторно
Natijani tekshirish|Проверить результат
Nomi bo‘yicha qidirish|Поиск по названию
Nomi yoki shtrix-kodni qo‘lda kiriting.|Введите название или штрихкод вручную.
Nomi, artikul yoki shtrix-kod|Название, артикул или штрихкод
Ochish|Открыть
Oldingi ombor operatsiyasi yakunlanmagan. Avval o‘sha natijani tekshiring.|Предыдущая складская операция не завершена. Сначала проверьте её результат.
Oldingi saqlash natijasi noma’lum. Shu operatsiyani xavfsiz qayta tekshiring.|Результат предыдущего сохранения неизвестен. Проверьте эту же операцию.
Ombor|Склад
Ombor tarifi mavjud emas|Склад недоступен на тарифе
Ombor va sotuv|Склад и продажи
Omborchi|Кладовщик
Operatsiya raqamini xavfsiz saqlab bo‘lmadi. Brauzer xotirasiga ruxsat bering.|Не удалось сохранить номер операции. Разрешите хранилище браузера.
Ortga|Назад
Oy|Месяц
Parol|Пароль
Parolni almashtirib bo‘lmadi|Не удалось изменить пароль
Parolni almashtirib bo‘lmadi.|Не удалось изменить пароль.
Parolni almashtirish|Изменить пароль
Parolni ko‘rsatish|Показать пароль
Parolni tiklash|Восстановить пароль
Parolni yashirish|Скрыть пароль
Profil|Профиль
Profilni tahrirlash|Изменить профиль
QR yuklanmoqda…|Загрузка QR…
Qarz|Долг
Qarz muddati|Срок долга
Qarz muddati (kun)|Срок долга (дней)
Qarz muddati 1 dan 3650 kungacha bo‘lishi kerak.|Срок долга должен быть от 1 до 3650 дней.
Qarz:|Долг:
Qarzli kirim uchun yetkazib beruvchini tanlang.|Для прихода с долгом выберите поставщика.
Qarzli sotuv uchun mijozni tanlang yoki yarating.|Для продажи с долгом выберите или создайте клиента.
Qarzli tasdiqlash uchun mijozni tanlang.|Для подтверждения с долгом выберите клиента.
Qayta|Повторить
Qayta urinish|Попробовать снова
Qaytariladigan tovar va miqdorni kiriting.|Укажите возвращаемый товар и количество.
Qaytarish miqdori filial zaxirasidan oshmasligi kerak.|Количество возврата не должно превышать остаток филиала.
Qaytarish sababi (ixtiyoriy)|Причина возврата (необязательно)
Qaytarish uchun filial zaxirasi yetarli emas.|Недостаточный остаток филиала для возврата.
Qaytarishni saqlash|Сохранить возврат
Qaytdi:|Возвращено:
Qidiruv bo‘yicha avtomobil topilmadi.|Автомобиль по запросу не найден.
Qidiruv bo‘yicha mijoz topilmadi.|Клиент по запросу не найден.
Qisqacha mazmun|Краткое содержание
Qiymat ko‘rsatilmaydi; amal zaxirani kamaytiradi.|Стоимость не показывается; операция уменьшает остаток.
Qoldiq:|Остаток:
Qoralamani davom ettirish|Продолжить черновик
Qoralamani o‘chirib yangi ish|Удалить черновик и создать работу
Qoralamani qurilmada saqlab bo‘lmadi. Sahifani yangilamang.|Не удалось сохранить черновик. Не обновляйте страницу.
Qo‘shish|Добавить
Rahmat|Спасибо
Raqam, model yoki mijoz|Госномер, модель или клиент
Ro‘yxatdan tashqari mijoz nomi (ixtiyoriy)|Имя клиента вне списка (необязательно)
Ruxsat olish|Получить доступ
Ruxsat yo‘q|Нет доступа
Sabab|Причина
Sahifa topilmadi|Страница не найдена
Saqlangan qoralama|Сохранённый черновик
Saqlash|Сохранить
Saqlash natijasi noma’lum. Shu operatsiyani xavfsiz qayta tekshiring.|Результат сохранения неизвестен. Проверьте эту же операцию.
Saqlash natijasi noma’lum. Takrorlamasdan tekshirish uchun shu operatsiyani qayta yuboring.|Результат сохранения неизвестен. Повторите эту же операцию для безопасной проверки.
Saqlash natijasi tekshirilmoqda|Проверка результата сохранения
Server javobi kutilmoqda. Natijani tekshiramiz.|Ожидание ответа сервера. Проверяем результат.
Sessiya o‘zgardi|Сеанс изменился
Sessiyani tekshiring va qayta urinib ko‘ring|Проверьте сеанс и попробуйте снова
Shablon|Шаблон
Shaxsiy tushum|Личная выручка
Shtrix-kod skaneri|Сканер штрихкода
Shtrix-kodni serverdan qidirish|Найти штрихкод на сервере
Shtrix-kodni skanerlash|Сканировать штрихкод
Singan|Повреждено
Siz bajargan ishlar bo‘yicha shaxsiy natijalar.|Личные результаты по выполненным работам.
Sizga vazifa biriktirilmagan|Вам не назначена роль
Skanerlash amalga oshmadi|Не удалось сканировать
Skanerni yopish|Закрыть сканер
Sotildi|Продано
Sotilgan miqdor band qilingan miqdordan oshmasligi kerak.|Проданное количество не должно превышать резерв.
Sotuv miqdori filial zaxirasidan oshmasligi kerak.|Количество продажи не должно превышать остаток филиала.
Sotuv narxi|Цена продажи
Sotuv qaytarildi|Возврат продажи сохранён
Sotuv qaytarish|Возврат продажи
Sotuv saqlandi|Продажа сохранена
Sotuv:|Продажа:
Sotuvchi|Продавец
So‘nggi ishlar|Последние работы
So‘rov bajarilmadi|Запрос не выполнен
So‘rov bekor qilindi|Запрос отменён
Statistika|Статистика
Taklif bildirish|Предложение
Takroriy ish yaratilmasligi uchun avval shu saqlash natijasini aniqlang.|Сначала проверьте результат сохранения, чтобы не создать повторную работу.
Tanlang|Выберите
Tanlangan avtomobil mijozga tegishli emas.|Выбранный автомобиль не принадлежит клиенту.
Tanlangan davrda ish yo‘q.|За выбранный период нет работ.
Tanlangan mijoz ustaxonada topilmadi.|Выбранный клиент не найден в мастерской.
Tanlangan tovarlar|Выбранные товары
Tanlanmagan|Не выбрано
Tanlovni yopish|Закрыть выбор
Tannarx|Себестоимость
Tannarx:|Себестоимость:
Tarix|История
Tasdiqlash|Подтвердить
Telefon|Телефон
Telefon raqami|Номер телефона
Nomi yoki telefon raqami|Имя или номер телефона
Yetkazib beruvchi qidirish|Поиск поставщика
Mos yetkazib beruvchi topilmadi.|Подходящий поставщик не найден.
Telefon raqami va parolni kiriting|Введите номер телефона и пароль
Telefon raqami yoki parol noto‘g‘ri|Неверный номер телефона или пароль
Telefon yoki davlat raqami|Телефон или госномер
Telegram holati yangilanmoqda…|Обновление статуса Telegram…
Telegram yoki telefon sozlamalarida kamera ruxsatini yoqing. Quyidagi qo‘lda qidiruv ishlashda davom etadi.|Разрешите камеру в настройках Telegram или телефона. Ручной поиск ниже остаётся доступен.
Terminal|Терминал
Til|Язык
Tizim|Система
Tovar kirimi|Приход товара
Tovar kirimi saqlandi|Приход сохранён
Tovar sotish|Продать товар
Tovar va mavjud miqdorni to‘g‘ri kiriting.|Укажите товар и доступное количество.
Tovar yoki shtrix-kod qidirish|Поиск товара или штрихкода
Tovar, miqdor va narxlarni tekshiring.|Проверьте товар, количество и цены.
Tovarlar|Товары
Tovarlar funksiyasi joriy tarifda yoqilmagan.|Товары недоступны на текущем тарифе.
Tovarni band qilish|Зарезервировать товар
To‘langan summa|Оплаченная сумма
To‘langan summa jami summadan oshmasligi kerak.|Оплата не должна превышать итоговую сумму.
To‘langan summa sotuv summasidan oshmasligi kerak.|Оплата не должна превышать сумму продажи.
To‘langan summani to‘g‘ri kiriting.|Введите корректную сумму оплаты.
To‘liq ism|Полное имя
To‘lov usuli|Способ оплаты
Ulangan|Подключён
Ulanmagan|Не подключён
Usta|Мастер
Usta ilovasiga kirish|Вход для мастера
Ustaxona avtomobillari.|Автомобили мастерской.
Ustaxona egasi sizga usta, sotuvchi yoki omborchi huquqini biriktirgach biznes bo‘limlari ochiladi.|Рабочие разделы откроются, когда владелец назначит роль мастера, продавца или кладовщика.
Ustaxona egasi · to‘liq ruxsat|Владелец мастерской · полный доступ
Ustaxona hisobingizdagi telefon va paroldan foydalaning.|Используйте телефон и пароль вашей учётной записи мастерской.
Ustaxona mijoz kartasi.|Карточка клиента мастерской.
Ustaxonadagi barcha mijoz avtomobillari.|Все автомобили клиентов мастерской.
Ustaxonadagi barcha mijozlar.|Все клиенты мастерской.
Ustaxonaning umumiy QR kodini mijozga skaner qildiring.|Попросите клиента отсканировать общий QR-код мастерской.
Vaqtinchalik parolni almashtirgach ilovaga kirishingiz mumkin.|Для доступа к приложению измените временный пароль.
Xabar matni|Текст сообщения
Xabar yuborildi|Сообщение отправлено
Xabar yuborilmadi|Не удалось отправить сообщение
Xabar yuborish|Отправить сообщение
Xarid qaytarildi|Возврат покупки сохранён
Xarid qaytarish|Возврат покупки
Xaridor|Покупатель
Xatolik yuz berdi|Произошла ошибка
Xizmat|Услуга
Xizmat narxi|Стоимость услуги
Xizmat narxini to‘g‘ri kiriting.|Введите корректную стоимость услуги.
Xizmat va tarif ma’lumotlari yuklanmoqda…|Загрузка услуг и тарифа…
Xizmatlar|Услуги
Xizmatni tanlang|Выберите услугу
Xizmatni tanlang.|Выберите услугу.
Xodim|Сотрудник
Yakunlanmagan operatsiya|Незавершённая операция
Yana ko‘rsatish|Показать ещё
Oldingi sahifa|Предыдущая страница
Keyingi sahifa|Следующая страница
Yangi|Новое
Yangi amal bloklangan. Avval saqlangan operatsiyani xavfsiz tekshiring.|Новая операция заблокирована. Сначала проверьте сохранённую операцию.
Yangi band|Новый резерв
Yangi davr yuklanmoqda…|Загрузка нового периода…
Yangi ish|Новая работа
Yangi ish, to‘lov va eslatma yaratish.|Создание работы, оплаты и напоминания.
Yangi ma’lumot paydo bo‘lganda shu yerda ko‘rinadi.|Новые данные появятся здесь.
Yangi mijoz|Новый клиент
Yangi mijoz ismi va telefonini kiriting.|Введите имя и телефон нового клиента.
Yangi parol|Новый пароль
Yangi parol kamida 8 ta belgidan iborat bo‘lishi kerak|Новый пароль должен содержать не менее 8 символов
Yangi parol kamida 8 ta belgidan iborat bo‘lishi kerak.|Новый пароль должен содержать не менее 8 символов.
Yangi parol kamida 8 ta belgidan iborat bo‘lsin.|Новый пароль должен содержать не менее 8 символов.
Yangi parol o‘rnating|Установите новый пароль
Yangi parollar bir xil emas|Новые пароли не совпадают
Yangi parollar bir xil emas.|Новые пароли не совпадают.
Yangi parolni takrorlang|Повторите новый пароль
Yangi tanlov:|Новый выбор:
Yangi yetkazib beruvchi nomi|Имя нового поставщика
Yetkazib beruvchi|Поставщик
Yetkazib beruvchi (ixtiyoriy)|Поставщик (необязательно)
Yetkazib beruvchi ma’lumotini kiriting.|Введите данные поставщика.
Yili|Год
Yilni to‘g‘ri kiriting.|Введите корректный год.
Yordam|Помощь
Yo‘qolgan|Утеряно
Yuborish|Отправить
Yuklab bo‘lmadi|Не удалось загрузить
Yuklanmoqda|Загрузка
Saqlanmoqda…|Сохранение…
Chiqilmoqda…|Выход…
Kirilmoqda…|Вход…
ulangan|подключён
ulanmagan|не подключён
ta avtomobil|автомобилей
Ishlar|Работы
Eslatmalar|Напоминания
Yuborilgan|Отправлено
Rejalashtirilgan|Запланировано
Ish qidirish|Поиск работы
Mijoz, raqam yoki xizmat|Клиент, номер или услуга
Qidiruv bo‘yicha ish topilmadi.|Работы по запросу не найдены.
Eslatma holati|Статус напоминания
Bu holatda eslatma yo‘q.|Напоминаний с таким статусом нет.
Hozir yuborish|Отправить сейчас
Mijozni ulash|Подключить клиента
Mijoz ushbu QR-kodni Telegram orqali skanerlasin.|Попросите клиента отсканировать этот QR-код через Telegram.
Yopish|Закрыть
8 soatlik ish qoralamasi muddati tugadi.|Истёк восьмичасовой срок черновика работы.
. Davom etish eski qoralamani o‘chiradi.|. Продолжение удалит старый черновик.
Saqlanmagan o‘zgarishlar|Несохранённые изменения
Takroriy qaytarish yaratilmasligi uchun avval shu saqlash natijasini aniqlang.|Сначала проверьте результат сохранения, чтобы не создать повторный возврат.
Chiqishni tasdiqlaysizmi? Qaytarish qoralamasi 8 soat saqlanadi.|Подтвердить выход? Черновик возврата сохраняется на 8 часов.
Qolish|Остаться
Muvaffaqiyatli|Успешно
Mos mijoz topilmadi.|Подходящий клиент не найден.
Yetkazib beruvchidan qarzimiz|Наш долг поставщику
Har bir to‘lov usulini bir marta tanlang.|Выберите каждый способ оплаты только один раз.
To‘langan summani kiriting.|Введите оплаченную сумму.
To‘langan summa 0 va jami summa orasida bo‘lishi kerak.|Оплаченная сумма должна быть между нулём и общей суммой.
To‘lov bo‘lmasa, to‘lov usuli ko‘rsatilmaydi.|Без оплаты способ оплаты не указывается.
Qiymatni tekshiring.|Проверьте значение.
Qiymat kiritilishi shart.|Необходимо ввести значение.
Butun son kiriting.|Введите целое число.
Son kiriting.|Введите число.
So‘rov rad etildi. Xato kodi:|Запрос отклонён. Код ошибки:
Band qilingan mijozni o‘zgartirib bo‘lmaydi.|Нельзя изменить клиента бронирования.
`.trim().split("\n").map((line) => line.split("|")));
